import { ArrowUp } from './ArrowUp';

export function ArrowDown() {
  return (
    <div>
      <ArrowUp style={{ transform: 'rotate(180deg)' }} />
    </div>
  );
}
